(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Jsw"] = factory();
	else
		root["Jsw"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 165);
/******/ })
/************************************************************************/
/******/ ({

/***/ 165:
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./app/database/active-list.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

var ce = Jsw.createElement;

var ActiveList = Class.create(Jsw.ActiveList, {
    _initConfiguration: function _initConfiguration($super, config) {
        $super(config);
        this.domains = this._getConfigParam('domains', []);
    },
    itemCaptionHeadView: function itemCaptionHeadView($super, item) {
        var _this = this;

        var view = $super(item);
        var users = item.users.slice(0, 4);

        view.children.push(ce('.caption-summary', ce('.caption-summary-wrap', ce('span.summary-item', ce('b', this.lmsg('hostLabel') + ('' + item.serverHost + (item.serverPort > 0 ? ':' + item.serverPort : '') + ' (' + item.typeTitle + ')').escapeHTML()), item.hasConnectionError ? [' ', ce('span.state-error', this.lmsg('serverUnavailable'))] : ''), ce('span.summary-item', item.users.length ? [this.lmsg('users'), ': ', ce('b', users.map(function (_ref) {
            var id = _ref.id,
                login = _ref.login;
            return '<a href="' + _this.urls['edit-user'] + '/id/' + id + '">' + login + '</a>';
        }).join(', ') + (item.users.length > users.length ? ',&nbsp;...' : ''))] : [ce('span.state-error', this.lmsg('noUsers')), item.hasConnectionError ? '' : [' ', ce('a', { href: this.urls['create-user'] + '/database/' + item.id }, '[' + this.lmsg('addUser') + ']')]]), item.hasConnectionError ? '' : ce('span.summary-item.ajax-loading', this.lmsg('calculatingSize')))));

        return view;
    },
    itemCaptionHeadWrapView: function itemCaptionHeadWrapView($super, item) {
        var view = $super(item);

        if (item.allowWebadmin) {
            view.children.unshift(ce('span.caption-head-widget', ce('a.btn', { onclick: this.itemActions.openWebAdmin.bind(this, item) }, item.webAdminTitle)));
        }

        var relatedDomains = this.domains.filter(function (_ref2) {
            var lastDatabaseSelectedId = _ref2.lastDatabaseSelectedId;
            return item.id === lastDatabaseSelectedId;
        }).map(function (_ref3) {
            var name = _ref3.name;
            return name;
        });

        view.children.push(ce('span.caption-head-action', item.isUsedByApp ? item.assignedDomainName ? this.lmsg('relatedToDomains', { domains: item.assignedDomainName }) : '' : relatedDomains.length > 0 ? [this.lmsg('relatedToDomains', { domains: relatedDomains.join(', ') }), ' ', ce('a.toggler', { onclick: this.changeRelatedDomains.bind(this, item) }, this.lmsg('changeRelatedDomain'))] : ce('a.toggler', { onclick: this.changeRelatedDomains.bind(this, item) }, this.lmsg('noRelatedDomains'))));

        if (!item.isUsedByApp) {
            view.children.push(ce('span.caption-head-action', { style: 'display: none;' }, this.lmsg('relatedToDomains', { domains: '' }), ce('select', ce('option', { value: '' }, this.lmsg('noDomainRelations')), this.domains.map(function (_ref4) {
                var id = _ref4.id,
                    name = _ref4.name,
                    lastDatabaseSelectedId = _ref4.lastDatabaseSelectedId;
                return ce('option' + (item.id === lastDatabaseSelectedId ? '[selected]' : ''), { value: id }, name);
            })), ' ', ce('a.btn', { onclick: this.setRelatedDomains.bind(this, item) }, this.lmsg('buttonOk'))));
        }
        return view;
    },
    render: function render($super) {
        var _this2 = this;

        $super();

        new Ajax.Request(this.urls['list-size-data'], {
            method: 'get',
            onSuccess: function onSuccess(_ref5) {
                var responseJSON = _ref5.responseJSON;

                responseJSON.forEach(function (item) {
                    var el = _this2.getItemElement(item);
                    var hostItemEl = el.down('.summary-item:first');
                    if (hostItemEl.down('.state-error')) {
                        return;
                    }
                    if (item.hasConnectionError) {
                        hostItemEl.insert(' <span class="state-error">' + _this2.lmsg('serverUnavailable') + '</span>');
                        el.down('.summary-item:last').remove();
                    } else {
                        el.down('.summary-item:last').replace('<span class="summary-item">' + _this2.lmsg('tables') + ': <b>' + item.tables + '</b></span>' + ('<span class="summary-item">' + _this2.lmsg('size') + ': <b>' + item.size + '</b></span>'));
                    }
                });
            }
        });
    },
    changeRelatedDomains: function changeRelatedDomains(item) {
        var actions = this.getItemElement(item).select('.caption-head-action');
        actions[0].hide();
        actions[1].show();
    },
    setRelatedDomains: function setRelatedDomains(item) {
        var el = this.getItemElement(item);
        Jsw.redirectPost(this.urls['set-related-domain'], {
            id: item.id,
            domainId: el.down('.caption-head-action select').getValue()
        });
    }
});

module.exports = ActiveList;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// javascript/app/database/active-list.js